import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Dashboard2 from './components/dashboard/Dashboard2'
import SignIn from './components/auth/SignIn'
import SignUp from './components/auth/SignUp'


class App extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      checked: []
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked
    });
  }

  render() {

    const { auth } = this.props;
    const { classes } = this.props;
    return ( 
      <BrowserRouter>
      
        <div className="App">
         
         
          <Switch>

            //TODO: Import from NavRoutes 
            
            <Route path="/invite/:companyName/:projectName" component={Dashboard2}/>
            <Route path='/signin' component={SignIn}/>
            <Route path='/signup' component={SignUp} />
            
            <Route path='/journals' component={Dashboard2} />
            <Route path='/journal/:id' component={Dashboard2} />
            <Route path='/locations' component={Dashboard2} />
            <Route path='/reports' component={Dashboard2} />
            <Route path='/administration' component={Dashboard2} />
            <Route path='/' component={Dashboard2} />
          </Switch>
        </div>
      </BrowserRouter>
    );/*
    return (
      <FormControlLabel 
      control={<Checkbox
                            tabIndex={-1}
                            onClick={() => this.handleToggle(1)}
                            
                          />}/>
      
    )*/
  }
}

/*const mapDispatchToProps = (dispatch) => {
  return {
    
    
    getProjects: () => dispatch(getProjects())
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    
    auth: state.firebase.auth
  }
}

export default 
  connect(mapStateToProps, mapDispatchToProps)(App);*/
  export default App;



// WEBPACK FOOTER //
// ./src/App.js